import { TBlogModuleHero } from '@/app/(blogposts)/blog/blog.types';
import { Typography } from '@/components/ui/Text';
import { assetUrl } from '@/lib/directus/assetUrl';
import Image from 'next/image';

import './BlogArticleModuleHeroDesktop.scss';

type Props = {
  module: TBlogModuleHero;
};

export const BlogArticleModuleHeroDesktop: React.FC<Props> = ({
  module: { heroImage, title, tag, textColor, overlayHEX },
}) => (
  <div className='BlogArticleModuleHeroDesktop'>
    <div className='BlogArticleModuleHeroDesktop__main-image-wrapper'>
      <Image
        src={assetUrl(heroImage) || ''}
        alt='hero'
        className='BlogArticleModuleHeroDesktop__main-image'
        fill
      />

      {overlayHEX && (
        <div
          className='BlogArticleModuleHeroDesktop__main-image-overlay'
          style={{ backgroundColor: overlayHEX }}
        />
      )}
    </div>

    <div className='BlogArticleModuleHeroDesktop__content'>
      {tag && (
        <div
          className='BlogArticleModuleHeroDesktop__tag'
          style={{ color: textColor ? textColor : undefined }}
        >
          <Typography variant='body-small'>{tag}</Typography>
        </div>
      )}

      <div
        className='BlogArticleModuleHeroDesktop__title'
        style={{ color: textColor ? textColor : undefined }}
      >
        <Typography variant='h1'>{title}</Typography>
      </div>
    </div>
  </div>
);
